import { render, staticRenderFns } from "./CategoryEntry.vue?vue&type=template&id=52875f50&scoped=true&"
import script from "./CategoryEntry.vue?vue&type=script&lang=js&"
export * from "./CategoryEntry.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEntry.vue?vue&type=style&index=0&id=52875f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52875f50",
  null
  
)

export default component.exports